export default [
    {
        label: '直接下载到设备，方便、快捷的操作省时省力'
    },
    {
        label: '原生型的APP可以调用手机端的硬件设备'
    },
    {
        label: '比Web App和混合App运行快，系统更加流畅'
    },
    {
        label: '用户可以自由地选择是否更新软件版本'
    }
];
